import React from 'react';
import PropTypes from 'prop-types';

const Input = (props) => {
	const {type, className, value, onChange, inputRef, ...rest} = props;

	return (
		<input type={type} className={className} value={value} onChange={onChange} ref={inputRef} {...rest}/>
	);
};

Input.defaultProps = {
	type: 'text',
	className: 'form-control'
};

Input.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	onChange: PropTypes.func.isRequired,
	type: PropTypes.string.isRequired,
	className: PropTypes.string,
	inputRef: PropTypes.func
};

export default Input;
